import { Stack } from "@mui/material";
import React from "react";

import { SkeletonIndicator } from "components/common/AnimatedWebcam/SkeletonIndicator";

export function ImageQueryPanelSkeleton() {
  return (
    <Stack className="gap-2" data-testid="image-query-panel-skeleton">
      {SkeletonIndicator({ loading: true, height: 32 })}
      {SkeletonIndicator({ loading: true, height: 52 })}
      {SkeletonIndicator({ loading: true, height: 558 })}
      {SkeletonIndicator({ loading: true, height: 250 })}
    </Stack>
  );
}
